import React from 'react'
import {
  FcDepartment,
  FcReadingEbook,
  FcConferenceCall,
  FcDam,
} from 'react-icons/fc'
import ControlButtons from './ProfileControlPanelComponents/ControlButtons'
import ControlPanelDialogsContent from './ProfileControlPanelComponents/ControlPanelDialogsContent'
import StateEngine from '../../smallComponents/StateEngine'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

const ControlPanel = ({ profileProps }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const { t } = useTranslation()
  const iconStyle = {
    marginRight: !rtl && 10,
    marginLeft: rtl && 10,
    fontSize: 20,
  }
  const controlPanelButtonsII = [
    {
      name: t('Contributors'),
      icon: <FcConferenceCall style={iconStyle} />,
      pureIcon: FcConferenceCall,
      margin: rtl ? '10px 10px 10px 5px' : '10px 5px 10px 10px',
    },
    {
      name: t('Control'),
      icon: <FcDepartment style={iconStyle} />,
      pureIcon: FcDepartment,
      margin: '10px 5px 10px 5px',
    },
    {
      name: t('Ideas_&_Inquiries'),
      icon: <FcReadingEbook style={iconStyle} />,
      pureIcon: FcReadingEbook,
      margin: '10px 5px 10px 5px',
    },
    {
      name: t('Projects_&_Deals'),
      icon: <FcDam style={iconStyle} />,
      pureIcon: FcDam,
      margin: rtl ? '10px 5px 10px 10px' : '10px 10px 10px 5px',
    },
  ]

  const controlPanelButtons = StateEngine({
    StatesArray: controlPanelButtonsII,
  })

  return (
    <ControlButtons
      modelCardsContentArray={controlPanelButtons}
      DialogsComponentContent={ControlPanelDialogsContent}
      profileProps={profileProps}
    />
  )
}

export default ControlPanel
